import { Pipe, PipeTransform } from '@angular/core';

import { DsLoadingSize } from '@type/ds-loading-size.type';
import { DsLoadingSpinnerMetric } from '@design-system/ds-loading-spinner/types/ds-loading-spinner-metric.type';
import { getDsLoadingSpinnerMetric } from '@design-system/ds-loading-spinner/helpers/get-ds-loading-spinner-metric.helper';

@Pipe({
  name: 'dsLoadingSpinnerMetric',
  standalone: true,
})
export class DsLoadingSpinnerMetricPipe implements PipeTransform {
  /**
   * Resolves circular spinner diameter or stroke width from a size variant.
   *
   * @param size - Spinner size variant
   * @param metric - Whether to resolve diameter or stroke width
   * @param override - Optional pixel override
   * @returns Pixel value for `mat-progress-spinner`
   */
  transform(size: DsLoadingSize, metric: DsLoadingSpinnerMetric, override: number | null | undefined = null): number {
    return getDsLoadingSpinnerMetric(size, metric, override);
  }
}
